import {ValueAndLabelModel} from '../../../../model/valueAndLabel.model';

export class LovListModelModel {
    hasParent: boolean;
    paramType: ValueAndLabelModel;
    paramLabel: string;
    hasComment: boolean;
}
